import React, { useState, useCallback } from 'react'
import useEventListener from './useEventListener'
import { useEffect } from './index'


const useInfiniteScroll = ({ elementRef, offsetBottom, items }) => {
  const [ state, setState ] = useState({ initialHeight: null, updatedHeight: null, updatedItems: [] })
  const { initialHeight, updatedHeight, updatedItems } = state

  useEffect(() => {
    if (items && items.length && !updatedItems.length) {
      setState({ updatedItems: items })
    }
  }, [ items, updatedItems ])

  const handleScroll = useCallback(() => {
    const { children, scrollTop, scrollHeight, offsetHeight } = elementRef.current

    if (!initialHeight) {
      setState({ initialHeight: offsetHeight, updatedItems })
    }
    // if (initialHeight && !updatedHeight && initialHeight !== offsetHeight) {
    //   setState({ updatedHeight: offsetHeight })
    // }
    // if (initialHeight && updatedHeight && updatedHeight !== offsetHeight) {
    //   elementRef.current.scrollTop = elementRef.current.scrollTop - initialHeight
    // }
    console.log({ offsetHeight, scrollTop, scrollHeight })
    const scrollBottom = scrollHeight - scrollTop - offsetHeight

    if (scrollBottom < offsetBottom && initialHeight) {
      const half = updatedItems.length / 2
      const firstPart = updatedItems.filter((item, index) => index <= half)
      const lastPart = updatedItems.filter((item, index) => index > half)

      console.log({ firstPart, lastPart })
      setState({
        initialHeight,
        updatedItems: [ ...lastPart, ...firstPart ],
      })
      setTimeout(() => {
        elementRef.current.scrollTop = initialHeight - elementRef.current.scrollTop
      }, 0)
      console.log('run')
    }
  }, [ offsetBottom, initialHeight, updatedHeight, updatedItems ])

  useEventListener('scroll', handleScroll, elementRef.current)

  console.log({ updatedItems })
  // window.el = elementRef.current
  return {
    updatedItems,
  }
}


export default useInfiniteScroll
